<template>
  <v-menu bottom
          ref="menu"
          class="dropdown-menu"
          z-index="1000"
          v-model="openMenu"
          :top="top"
          :offset-y="offsetY"
          :offset-x="offsetX"
          :left="left"
          :right="right"
          :disabled="disabled">
    <template v-slot:activator="{ on }">
            <span class="activator-container" v-on="on" @click.stop="openMenuFunc">
                <slot/>
            </span>
    </template>

    <div>
      <v-list
        v-click-outside="closeMenu"
        :class="['dropdown-menu-list-wrapper', {'dropdown-menu-list-wrapper--dark-icons': darkIcons}]">
        <v-list-item
          :data-qa="item.action"
          v-for="(item, i) in items"
          :key="i"
          :disabled="item.disabled"
          @click="onItemClick(item)">
          <v-icon small v-if="item.icon">{{ item.icon }}</v-icon>
          <VSvgIcon v-if="item.svg" :tag="item.svg_tag" size="24" :icon="item.svg" class="svg-icon"/>
          <v-list-item-title v-if="!item.items">
            {{item.titleKey ? $t(item.titleKey) : item.title}}
          </v-list-item-title>
          <v-list-item-title
            v-if="item.items">
            <DropdownMenu
              :items="item.items"
              :offsetX="true"
              @item-clicked="onItemClick">
              <v-list-item-title>{{item.titleKey ? $t(item.titleKey) : item.title}}
                <v-icon size="15" class="additional-icon icon-gallery_right"/>
              </v-list-item-title>
            </DropdownMenu>
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </div>
  </v-menu>
</template>

<script>
  import VSvgIcon from '../VSvgIcon'
  import ClickOutside from 'vue-click-outside'

  // scroll events don't bubble, so listen in the capture phase to catch any scrolling container
  const SCROLL_LISTENER_OPTIONS = {capture: true, passive: true}

  export default {
    name: "DropdownMenu",
    components: {
      VSvgIcon
    },
    props: {
      items: {
        type: Array,
        required: true,
      },
      top: {
        type: Boolean,
        required: false,
      },
      offsetX: {
        type: Boolean,
        required: false,
      },
      offsetY: {
        type: Boolean,
        required: false,
      },
      left: {
        type: Boolean,
        required: false,
      },
      right: {
        type: Boolean,
        required: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      darkIcons: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        openMenu: false
      }
    },
    beforeDestroy() {
      this.toggleScrollListener(false)
    },
    directives: {
      ClickOutside
    },
    methods: {
      closeMenu() {
        this.openMenu = false
      },
      openMenuFunc() {
        this.openMenu = true
      },
      onItemClick(item) {
        !item.items && this.$emit('item-clicked', item)
      },
      toggleScrollListener(listen) {
        const method = listen ? 'addEventListener' : 'removeEventListener'

        document[method]('scroll', this.onScroll, SCROLL_LISTENER_OPTIONS)
      },
      onScroll({target}) {
        // the menu content is detached from its activator, so it keeps floating in place when an
        // ancestor (e.g. the conversation list) scrolls - close it instead, but ignore scrolling
        // inside the menu itself
        const content = this.$refs.menu && this.$refs.menu.$refs.content

        if (content && target instanceof Node && content.contains(target)) return

        this.closeMenu()
      }
    },
    watch: {
      openMenu(isOpen) {
        // wait a tick so the click/tap that opened the menu can't close it right away
        isOpen ? this.$nextTick(() => this.openMenu && this.toggleScrollListener(true))
               : this.toggleScrollListener(false)
      }
    }
  }
</script>

<style lang="scss">
  @import '@/assets/scss/abstract/_i18n-mixins';
  @import '@/assets/scss/abstract/_variables';

  .dropdown-menu-list-wrapper {
    &.v-list .v-list-item {
      min-height: 40px;

      .v-list-item__title {
        font-size: 13px;
      }

      .v-icon .additional-icon{
        margin-inline-start: auto ;
      }
    }

    .v-icon {
      margin-inline-end: 12px;
    }

    &--dark-icons .v-icon {
      color: $black-color-1;
    }

    .svg-icon {
      @include i-margin-mirror(0, 12px);
      min-width: 24px;
    }

  }
</style>
